var map = {
	"./GroupBot-Logo-Dark.png": "20be",
	"./GroupBot-Logo-Light.png": "aedd",
	"./GroupBot-Logo-Primary.png": "28d2",
	"./icons8-marker-24.png": "92a3",
	"./icons8-street-view-48.png": "76c6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9142";